import axios from 'axios';

export const getTakeRates = data => axios.post('/calculate-take-rates', data);

export const calculatePaymentMethodFee = data => axios.post('/payments/calculate-payment-method-fee', data);
